export default {
  lbl: {
    info: 'Informace',
    warning: 'Upozornění'
  },
  webform: {
    lbl: {
      pin_code: 'PIN kód',
      title: 'Formulář',
      btn_save: 'Надіслати',
      info_fields: "Поля, позначені *, є обов'язковими для заповнення",
      attachments: 'Вкладення'
    },
    msg: {
      list1: 'Na vaši emailovou adresu Vám byl zaslán PIN kód k přihlášení do webového formuláře.',
      list2: 'PIN kód musí obsahovat pouze číslice!',
      list3: 'Zadaný PIN kód je nesprávný!',
      list4: 'PIN kód byl znovu poslán na vaši emailovou adresu. Prosím překontrolujte si i složku SPAM.',
      login_title: 'Přihlášení k webovému formuláři',
      resend_pin: 'Poslat PIN kód znovu',
      err_not_save: 'Formulář sa nepodařilo odeslat.',
      err_link_title: 'Server je momentálně nedostupný!',
      err_link_desc: 'Server je dočasně nedostupný, pokud je to možné, opakujte akci později prosím.',
      err_link_title1: 'Platnost odkazu vypršela!',
      err_link_desc1: 'Pokoušíte se o otevření odkazu, kterému již vypršela platnost. Zřejmě jste klikli na odkaz ve starším emailu. Pokud jste opravdu přesvědčen o platnosti tohoto odkazu, kontaktujte společnost INDEX NOSLUŠ s.r.o.',
      err_link_title2: 'Neplatný odkaz!',
      err_link_desc2: 'Pokoušíte se načíst odkaz, který je neplatný! Zkontrolujte ještě jednou odkaz a pokuste se ho načíst znovu, pokud jste opravdu přesvědčen, o platnosti tohoto odkazu a nedaří se Vám ho správně načíst, kontaktujte společnost INDEX NOSLUŠ s.r.o.',
      err_link_title3: 'Platnost odkazu skončila!',
      err_link_desc3: 'Pokoušíte se o otevření odkazu, který již není platný.',
      err_link_title4: 'Odkaz nemohol byť načítaný.',
      err_link_desc4: 'Zřejmě se pokoušíte o otevření odkazu, který není platný.'
    }
  },
  webdocument: {
    lbl: {
      pin_code: 'PIN kód',
      identication_nr: 'Rodné číslo',
      identication_nr_placeholder: 'Zadajte rodné číslo',
      title: 'Dokument',
      btn_save: 'Uložiť',
      sign: 'Kliknutím potvrdiť podpis',
      confirm_signatures: 'Potvrdiť podpisy',
      sign_document: 'Podpísať',
      cancel: 'Zrusiť',
      clear: 'Vymazať',
      confirmed: 'Potvrdený podpis',
      scroll: 'K podpisu',
      login: 'Prihlásiť sa'
    },
    msg: {
      fooma_add_signature: 'Pridajte Váš podpis',
      fooma_info_pc: 'Pomocou kurzora sa podpíšte',
      fooma_info_touch: 'Pomocou dotykovej obrazovky sa podpíšte',
      fooma_confirmed_signatures: 'Potvr. podpisy',
      list0: 'Prihláste sa pomocou vašeho rodného čisla.',
      list1: 'Na vaši emailovou adresu Vám byl zaslán PIN kód k přihlášení k podpisu dokumentu.',
      list2: 'PIN kód musí obsahovat pouze číslice!',
      list3: 'Zadaný PIN kód je nesprávný!',
      list4: 'PIN kód byl znovu poslán na vaši emailovou adresu. Prosím překontrolujte si i složku SPAM.',
      login_title: 'Přihlášení k podpisu dokumentu',
      resend_pin: 'Poslat PIN kód znovu',
      err_not_save: 'Dokument se nepodařilo podepsat.',
      err_link_title: 'Server je momentálně nedostupný!',
      err_link_desc: 'Server je dočasně nedostupný, pokud je to možné, opakujte akci později prosím.',
      err_link_title1: 'Platnost odkazu vypršela!',
      err_link_desc1: 'Pokoušíte se o otevření odkazu, kterému již vypršela platnost. Zřejmě jste klikli na odkaz ve starším emailu. Pokud jste opravdu přesvědčen o platnosti tohoto odkazu, kontaktujte společnost INDEX NOSLUŠ s.r.o.',
      err_link_title2: 'Neplatný odkaz!',
      err_link_desc2: 'Pokoušíte se načíst odkaz, který je neplatný! Zkontrolujte ještě jednou odkaz a pokuste se ho načíst znovu, pokud jste opravdu přesvědčen, o platnosti tohoto odkazu a nedaří se Vám ho správně načíst, kontaktujte společnost INDEX NOSLUŠ s.r.o.',
      err_link_title3: 'Platnost odkazu skončila!',
      err_link_desc3: 'Pokoušíte se o otevření odkazu, který již není platný.',
      err_link_title4: 'Odkaz nemohol byť načítaný.',
      err_link_desc4: 'Zřejmě se pokoušíte o otevření odkazu, který není platný.',
      sign_failed: 'Podepsání dokumentu selhalo.',
      sign_success_title: 'Podepsaný dokument byl úspěšně odeslán.',
      sign_saving_title: 'Podepsaný dokument se odesíla',
      sign_error_title: 'Podepsání dokumentu selhalo.',
      sign_success: 'Děkujeme.',
      sign_cancel: '',
      sign_saving: 'čekejte prosím...',
      sign_error: ''
    }
  },
  employee: {
    lbl: {
      firstname: 'Ім´я',
      surname: 'Прізвище',
      title: 'Титул перед ім´ям',
      title_suffix: 'Титул після імені',
      sex: 'Стать',
      male: 'Людина',
      female: 'жінка',
      email: 'Email',
      telephone: 'Номер телефону',
      address_txt: 'Adresa',
      address: {
        title: 'Прописка (в Україні)',
        street: 'Вулиця',
        house_nr: 'Номер',
        city: 'Місто',
        nrzip: 'Поштовий індекс',
        country: 'Країна'
      },
      contact_address: {
        title: 'Контактна адреса'
      },
      job_status: 'Ваш актуальний статус ',
      education_level: 'Найвищий рівень освіти',
      birth_nr: 'Особистий ідентифікаційний номер',
      birth_date: 'Дата народження',
      place_of_birth: 'Місце нородження',
      country_of_birth: 'країна народження',
      family_name: 'Дівоче прізвище',
      family_name_all: 'Усі попередні прізвища',
      citizenship: 'Громадянство',
      insurance_number: 'Номер страховки',
      document_number: 'Номер паспорта (або іншого документу)',
      marital_status: 'Сімейний стан',
      health_insurance: 'Медичне страхування',
      bank_account: 'Номер рахунку для заробітньої плати',
      bank_code: 'Код банку'
    },
    msg: {
      contact_address: 'Kontaktní adresu vyplňte pouze v případě, že se častěji nacházíte mimo vašeho trvalého bydliště.',
      val_firstname: 'Jméno je povinné vyplnit.',
      val_surname: 'Příjmení je povinné vyplnit.',
      val_sex: 'Pohlaví je povinné vyplnit.',
      val_address: 'Trvalé bydliště je povinné vyplnit.',
      val_job_status: 'Aktuální pracovní status je povinné vyplnit.',
      job_status_student: 'Pokud máte aktuální potvrzení o studiu, nahrajte ho prosím do příloh níže.',
      val_education_level: 'Nejvyšší dosažené vzdělání je povinné vyplnit.',
      val_place_of_birth: 'Místo narození je povinné vyplnit.',
      val_country_of_birth: 'Stát narození je povinné vyplnit.',
      val_family_name: 'Rodné příjmení je povinné vyplnit.',
      val_citizenship: 'Státní občanství je povinné vyplnit.',
      val_insurance_number: 'Číslo pojištěnce je povinné vyplnit.',
      val_document_number: 'Číslo dokladu je povinné vyplnit.',
      val_marital_status: 'Rodinný stav je povinné vyplnit.',
      val_health_insurance: 'Zdravotní pojišťovnu je povinné vyplnit.'
    }
  },
  webformtaxpay: {
    lbl: {
      tax_period_month: 'Zdaňovací období - měsíc',
      tax_period_year: 'Zdaňovací období - rok',
      tax_period: 'Zdaňovací období',
      payer_name: 'Název plátce daně',
      payer_address: 'Adresa plátce daně',
      taxpayer_firstname: 'Jméno',
      taxpayer_surname: 'Příjmení',
      taxpayer_birth_nr: 'Rodné číslo',
      taxpayer_address: 'Adresa bydliště (místo trvalého pobytu)',
      resident_birth_date: 'Datum narození',
      resident_document_number: 'Číslo a typ dokladu prokazujíci totožnost poplatníka',
      resident_document_country: 'Stát, který tento doklad vydal',
      resident_identification: 'Identifikace pro daňové účely ve státu daňové rezidence',
      resident_country: 'Stát, jehož jste daňovým rezidentem',
      title_35ba1: 'Podle § 35ba odst. 1 zákona uplatňuji',
      firstname: 'Jméno',
      surname: 'Příjmení',
      birth_nr: 'Rodné číslo',
      discount: 'Uplatňuji/neuplatňuji ve výši na',
      ztpp: 'ZTP/P',
      baby_dite: 'Zletilé dítě',
      additionally: 'Dodatečně za kal. měsíce',
      title_38k4: 'Podle § 38k odst. 4 zákona prohlašuji, že:',
      address: 'Adresa bydliště(místo trvalého pobytu)',
      is_discount_applies: 'Uplatňuje daňové zvýhodnění',
      is_employment: 'Zaměstnání'
    },
    msg: {
      login_title: 'Formulář - prohlášení poplatníka',
      tax_period: 'Vyplňte zdaňovací období',
      tax_period_month: 'Vyplňte měsíc(od) zdaňovací období',
      payer_name: 'Vyplňte název plátce daně',
      payer_address: 'Vyplňte adresu plátce daně',
      taxpayer_firstname: 'Vyplňte vaše jméno',
      taxpayer_surname: 'Vyplňte vaše příjmení',
      taxpayer_birth_nr: 'Vyplňte vaše rodné číslo',
      taxpayer_address: 'Vyplňte vaši adresu bydliště',
      is_resident: 'Jste daňový rezident ČR?',
      resident_document_number: 'Zadejte číslo a typ dokladu prokazujíci vaši totožnost',
      resident_document_country: 'Zadejte stát, který tento doklad vydal',
      resident_identification: 'Zadejte identifikaci',
      resident_country: 'Zadejte stát',
      discount1: 'Základní slevu na poplatníka (písm. a)',
      discount2: 'Základní slevu na invaliditu (písm. c)',
      discount2_desc: 'a prohlašuji, že mi byl přiznán invalidní důchod pro invaliditu I. nebo II. stupně z důchodového pojištění podle zákona o důchodovém pojištění, nebo že mi zanikl nárok na invalidní důchod pro invaliditu I. nebo II. stupně z důvodu souběhu nároku na výplatu tohoto invalidního důchodu a starobního důchodu',
      discount3: 'Rozšírenou slevu na invaliditu (písm. d)',
      discount3_desc: 'a prohlašuji, že mi byl přiznán invalidní důchod pro invaliditu III. stupně nebo jiný důchod z důchodového pojištění podle zákona o důchodovém pojištění, u něhož jednou z podmínek přiznání je, že jsem invalidní ve III. stupni, zanikl mi nárok na invalidní důchod pro invaliditu III. stupně z důvodu souběhu nároku na výplatu invalidního důchodu pro invaliditu III. stupně a starobního důchodu nebo, že jsem podle zvláštních předpisů invalidní ve III. stupni, avšak žádost o invalidní důchod pro invaliditu III. stupně mi byla zamítnuta z jiných důvodů než proto, že nejsem invalidní ve III. stupni',
      discount4: 'Slevu na držitele průkazu ZTP/P (písm. e)',
      discount4_desc: 'a prohlašuji, že mi byl přiznán nárok na průkaz ZTP/P',
      discount5: 'Slevu na studenta (písm. f)',
      discount5_desc: 'a prohlašuji, že se soustavně připravuji na budoucí povolání studiem nebo předepsaným výcvikem (do 26 let) nebo po dobu prezenční formy studia v doktorském studijním programu, který poskytuje vysokoškolské vzdělání (do 28 let)',
      is_benefits_for_children: 'Podle § 35c a § 35d zákona uplatňuji',
      val_tax_period: 'Zdaňovací období je povinné vyplnit.',
      val_payer_name: 'Název plátce daně je povinné vyplnit.',
      val_payer_address: 'Adresu plátce daně je povinné vyplnit.',
      val_taxpayer_firstname: 'Jméno je povinné vyplnit.',
      val_taxpayer_surname: 'Příjmení je povinné vyplnit.',
      val_taxpayer_birth_nr: 'Rodné číslo je povinné vyplnit.',
      val_taxpayer_address: 'Adresu bydliště je povinné vyplnit.',
      val_not_resident: 'V případě daňového nerezidenta je toto pole nutno vyplnit!',
      val_must_fill: 'Toto pole nutno vyplnit!'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/ua.js